module.exports = __webpack_public_path__ + "static/media/girl2.83724050.svg";